var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoToTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.45,
    height: 138.707,
    viewBox: "0 0 152.45 138.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7473",
    "data-name": "Grupo 7473",
    transform: "translate(-1606.739 -562.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20836",
    "data-name": "Trazado 20836",
    d: "M6.8-4.048H9.456a2.861,2.861,0,0,1-.9,1.808A3.207,3.207,0,0,1,6.176-1.3,3.466,3.466,0,0,1,3.5-2.368a4.293,4.293,0,0,1-1.1-2.9A4.325,4.325,0,0,1,3.536-8.256a3.85,3.85,0,0,1,2.816-1.1A3.6,3.6,0,0,1,8.24-8.9,4.349,4.349,0,0,1,9.552-7.68l1.3-.912a4.851,4.851,0,0,0-1.728-1.6,5.773,5.773,0,0,0-2.784-.672,5.686,5.686,0,0,0-4.016,1.6A5.7,5.7,0,0,0,.768-5.28,5.711,5.711,0,0,0,2.352-1.248,4.65,4.65,0,0,0,5.984.208a4.989,4.989,0,0,0,3.632-1.36A5.826,5.826,0,0,0,11.2-5.472v-.08H6.8Zm11.488-6.816a5.414,5.414,0,0,0-5.552,5.536A5.414,5.414,0,0,0,18.288.208,5.414,5.414,0,0,0,23.84-5.328,5.414,5.414,0,0,0,18.288-10.864Zm0,9.568a3.82,3.82,0,0,1-3.92-4.032,3.82,3.82,0,0,1,3.92-4.032,3.82,3.82,0,0,1,3.92,4.032A3.82,3.82,0,0,1,18.288-1.3Zm16.736-7.84v-1.536H28.5v1.536h2.448V0h1.632V-9.136Zm6.16-1.728a5.414,5.414,0,0,0-5.552,5.536A5.414,5.414,0,0,0,41.184.208a5.414,5.414,0,0,0,5.552-5.536A5.414,5.414,0,0,0,41.184-10.864Zm0,9.568a3.82,3.82,0,0,1-3.92-4.032,3.82,3.82,0,0,1,3.92-4.032A3.82,3.82,0,0,1,45.1-5.328,3.82,3.82,0,0,1,41.184-1.3ZM57.92-9.136v-1.536H51.392v1.536H53.84V0h1.632V-9.136Zm6.16-1.728a5.414,5.414,0,0,0-5.552,5.536A5.414,5.414,0,0,0,64.08.208a5.414,5.414,0,0,0,5.552-5.536A5.414,5.414,0,0,0,64.08-10.864Zm0,9.568a3.82,3.82,0,0,1-3.92-4.032A3.82,3.82,0,0,1,64.08-9.36,3.82,3.82,0,0,1,68-5.328,3.82,3.82,0,0,1,64.08-1.3Zm7.6-9.376V0h1.632V-4.336h.736a3.852,3.852,0,0,0,2.608-.832A2.989,2.989,0,0,0,77.7-7.5,3.089,3.089,0,0,0,76.368-10.1a4.171,4.171,0,0,0-2.336-.576Zm1.632,1.5h.72c1.856,0,2.1,1.056,2.1,1.648,0,.992-.672,1.68-2.08,1.68h-.736Z",
    transform: "translate(1664.5 701) rotate(-90)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7461",
    "data-name": "Grupo 7461",
    transform: "translate(1758.481 535.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7459",
    "data-name": "Grupo 7459",
    transform: "translate(0.241)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_26",
    "data-name": "L\\xEDnea 26",
    y1: 76,
    x2: 76,
    transform: "translate(27.259)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_27",
    "data-name": "L\\xEDnea 27",
    x1: 76,
    y1: 76,
    transform: "translate(27.259 75.036)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_28",
    "data-name": "L\\xEDnea 28",
    x1: 138,
    transform: "translate(27.5 75.518)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToTop);
export default __webpack_public_path__ + "bill-reader/static/media/go-to-top.018848cdd141b33bdf7abe741c2fcc5f.svg";
export { ForwardRef as ReactComponent };